export const FETCH_AI_DRAFT_CONTENT_FAILURE =
	'state.actions.fetch-ai-draft-content.FETCH_AI_DRAFT_CONTENT_FAILURE' as const;
export type FetchAIDraftContentFailurePayload = {
	topicId: string;
	error: Error | null;
};
export type FetchAIDraftContentFailureAction = {
	type: typeof FETCH_AI_DRAFT_CONTENT_FAILURE;
	payload: FetchAIDraftContentFailurePayload;
};

export const fetchAIDraftContentFailure = (
	payload: FetchAIDraftContentFailurePayload,
): FetchAIDraftContentFailureAction => ({
	type: FETCH_AI_DRAFT_CONTENT_FAILURE,
	payload,
});
